import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { SavedCardsResponse } from '~types/api/event';

export function useFetchSavedCards(options?: { enabled?: boolean }) {
  const token = useUserStore((state) => state.token);

  return useQuery<SavedCardsResponse, Error>(
    ['savedCards'],
    async () => {
      const response = await fetch(`${BASE_API_URL}users/saved-cards`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          Authorization: token,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to fetch saved cards');
      }

      return response.json();
    },
    {
      enabled: !!token && (options?.enabled !== false),
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );
}
